<template>
  <div>
    <div
        v-for="(farm, key) in value"
        :key="farmItemKey(farm, key)"
        class="p-3 rounded border mt-3"
    >
      <div>
        <span class="col-form-label">
            Apakah Petambak memiliki tambak terdaftar di
          <a href="https://app.jala.tech" rel="noopener" target="_blank">
            Jala Apps
          </a>?</span>
        <b-form-group v-slot="{ ariaDescribedby }" :state="Boolean(farm.use_jala_farm)" class="mb-2">
          <b-form-radio-group
              :id="`use-jala-farm-radio-group-${farm.id || farm.jala_farm_id || key}`"
              :disabled="disableExistingUseJalaFarm && Boolean(farm.id)"
              v-model="farm.use_jala_farm"
              :aria-describedby="ariaDescribedby"
              :name="`use-jala-farm-radio-sub-component-${farm.id || farm.jala_farm_id || key}`"
              @change="() => onUseJalaFarmChanged(farm)"
          >
            <b-form-radio
                :value="true"
            >{{ $t('customers.forms.jala_farms.jala_app_import_options.yes') }}
            </b-form-radio
            >
            <b-form-radio :value="false"
            >{{ $t('customers.forms.jala_farms.jala_app_import_options.no') }}
            </b-form-radio
            >
          </b-form-radio-group>
        </b-form-group>
        <template>
          <div class="row">
            <validation-provider
                v-if="farm.use_jala_farm"
                v-slot="{ validated, errors }"
                :name="lodash.startCase($t('customers.farms.name'))"
                class="col-md-6"
                rules="required"
                vid="farm_id"
            >
              <b-form-group
                  :invalid-feedback="errors[0]"
                  :label="lodash.startCase($t('customers.farms.name')) + '*'"
                  :state="errors[0] ? false : validated ? true : null"
                  class="row mb-3"
                  label-cols-md="12"
              >
                <multiselect-ajax
                    :key="`farms-region-${farm.region_id}-farms`"
                    v-model.number="farm.jala_farm_id"
                    :name="lodash.startCase($t('customers.farms.name')) + '*'"
                    :params="{ with: 'region' }"
                    :placeholder="
                      $t('Select {something}', {
                        something: $t('customers.farms.name'),
                      })
                    "
                    :url="`/jala/farms`"
                    required
                    @select="(value) => onExistingFarmSelected(farm, value)"
                    @remove="onFarmRemoved(farm)"
                >
                  <template v-slot:option="{ option }">
                    <span>{{ option.name }}</span><br/>
                    <span class="font-size-10">
                      {{ option.region.full_name }}
                    </span>
                  </template>
                </multiselect-ajax>
              </b-form-group>
            </validation-provider>
            <validation-provider
                v-else
                v-slot="{ validated, errors }"
                :name="lodash.startCase($t('customers.farms.name'))"
                :rules="`required`"
                :vid="`customers.farms.${key}.name`"
                class="col-md-6"
            >
              <b-form-group
                  :invalid-feedback="errors[0]"
                  :label="`${lodash.startCase($t('customers.farms.name'))}*`"
                  :state="errors[0] ? false : validated ? true : null"
                  class="row mb-3"
                  label-cols-md="12"
              >
                <b-form-input
                    v-model="farm.name"
                    :name="lodash.startCase($t('customers.farms.name'))"
                    :state="errors[0] ? false : validated ? true : null"
                    required
                    type="text"
                ></b-form-input>
              </b-form-group>
            </validation-provider>
            <validation-provider
                v-slot="{ validated, errors }"
                :name="lodash.startCase($t('customers.total_person'))"
                :vid="`customers.farms.${key}.total_person`"
                class="col-md-6"
                rules="min_value:0"
            >
              <b-form-group
                  :invalid-feedback="errors[0]"
                  :label="`${lodash.startCase($t('customers.total_person'))}`"
                  :state="errors[0] ? false : validated ? true : null"
                  class="row mb-3"
                  label-cols-md="12"
              >
                <b-form-input
                    v-model="farm.total_person"
                    :name="lodash.startCase($t('customers.total_person'))"
                    :state="errors[0] ? false : validated ? true : null"
                    required
                    type="number"
                    @mousewheel.native="$event.preventDefault()"
                ></b-form-input>
              </b-form-group>
            </validation-provider>
            <div class="col-md-12">
              <jala-region-select-ajax
                  v-model="farm.region_id"
                  :rules="regionRules"
                  :disables="regionDisables(farm, key)"
                  name="region_id"
              />
            </div>
            <validation-provider
                v-slot="{ validated, errors }"
                :name="lodash.startCase($t('customers.full_address'))"
                rules="required"
                vid="address"
            >
              <b-form-group
                  :invalid-feedback="errors[0]"
                  :label="lodash.startCase($t('customers.full_address'))"
                  :state="errors[0] ? false : validated ? true : null"
                  class="row mb-3"
                  label-class="required-indicator"
                  label-cols-md="12"
              >
                <b-form-textarea
                    v-model="farm.address"
                    :state="errors[0] ? false : validated ? true : null"
                    name="address"
                    type="text"
                    :disabled="addressDisabled(farm)"
                ></b-form-textarea>
              </b-form-group>
            </validation-provider>
            <div class="col-12">
              <customer-coordinate
                  :card-title="locationCardTitle"
                  :farm="farm"
                  :region="region"
              />
            </div>

          </div>
        </template>
        <div class="d-flex">
          <b-button
              v-if="!farm.id && key !== 0"
              class="mt-3 ms-auto"
              size="md"
              tag="span"
              variant="outline-danger"
              @click="value.splice(key, 1)"
          >
            <div class="d-flex align-items-center gap-3">
              <svg
                  fill="none"
                  height="16"
                  viewBox="0 0 16 16"
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M9.81558 1.4268C9.71666 1.36561 9.60264 1.33323 9.48633 1.33332L9.81558 1.4268ZM9.81558 1.4268C9.91449 1.48798 9.99437 1.57556 10.0462 1.67967L10.291 2.16665L9.81558 1.4268ZM4.05046 13.4636C4.06239 13.654 4.14643 13.8326 4.28546 13.9633C4.42449 14.0939 4.60807 14.1666 4.79883 14.1666L4.05046 13.4636ZM4.05046 13.4636C4.05046 13.4636 4.05046 13.4635 4.05045 13.4635M4.05046 13.4636L4.05045 13.4635M4.05045 13.4635L3.53159 5.16665H12.4671L11.9482 13.4635C11.9482 13.4635 11.9482 13.4636 11.9482 13.4636C11.9363 13.654 11.8523 13.8326 11.7132 13.9633C11.5742 14.0939 11.3906 14.1666 11.1999 14.1666C11.1998 14.1666 11.1998 14.1666 11.1998 14.1666M4.05045 13.4635L11.1998 14.1666M11.1998 14.1666H4.79889H11.1998ZM9.84428 2.39121L9.98273 2.66665H10.291H13.3327V3.33332H2.66602V2.66665H5.70768H6.01596L6.15442 2.39121L6.39921 1.90423L6.39923 1.90425L6.40165 1.89931C6.41136 1.87945 6.42647 1.86272 6.44526 1.85105C6.46404 1.83938 6.48573 1.83323 6.50784 1.83331V1.83332H6.50976L9.48633 1.83332L9.48668 1.83332C9.50995 1.8333 9.53275 1.83978 9.55253 1.85201C9.57232 1.86425 9.58829 1.88177 9.59866 1.90259L9.59866 1.90259L9.59949 1.90423L9.84428 2.39121Z"
                    fill="#DC1021"
                    stroke="#DC1021"
                />
              </svg>

              <div
                  style="font-weight: 700;font-size: 14px;line-height: 16px;color: #DC1021;"
              >
                Hapus Tambak
              </div>
            </div>
          </b-button>
        </div>
      </div>
    </div>
    <b-button
        class="mt-3"
        size="md"
        tag="span"
        variant="outline-dark"
        @click="addFarm"
    >
      <div class="d-flex align-items-center gap-3">
        <svg
            fill="none"
            height="16"
            viewBox="0 0 16 16"
            width="16"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M8.92727 6.57144V7.07144H9.42727H13.713C13.9627 7.07144 14.1654 7.27407 14.1654 7.52382V8.4762C14.1654 8.72595 13.9627 8.92858 13.713 8.92858H9.42727H8.92727V9.42858V13.7143C8.92727 13.964 8.72464 14.1667 8.47489 14.1667H7.52251C7.27276 14.1667 7.07013 13.964 7.07013 13.7143V9.42858V8.92858H6.57013H2.28441C2.03466 8.92858 1.83203 8.72595 1.83203 8.4762V7.52382C1.83203 7.27407 2.03466 7.07144 2.28441 7.07144H6.57013H7.07013V6.57144V2.28572C7.07013 2.03597 7.27276 1.83334 7.52251 1.83334H8.47489C8.72464 1.83334 8.92727 2.03597 8.92727 2.28572V6.57144Z"
              fill="#454646"
              stroke="#454646"
          />
        </svg>
        <div
            style="font-weight: 700;font-size: 14px;line-height: 16px;color: #363637;"
        >
          Tambah Tambak
        </div>
      </div>
    </b-button>
  </div>
</template>

<script>
import JalaRegionSelectAjax from "@/components/forms/customer/jala-region-select-ajax.vue";
import MultiselectAjax from "@/components/inputs/vue-multiselect-ajax";
import CustomerCoordinate from "@/components/forms/customer/customer-coordinate.vue";

export default {
  name: "customer-farm",
  components: {
    JalaRegionSelectAjax,
    MultiselectAjax,
    CustomerCoordinate,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disableExistingUseJalaFarm: {
      type: Boolean,
      default: false,
    },
    disableRegionSelectWhenFarmFetched: {
      type: Boolean,
      default: false,
    },
    disableAddress: {
      type: Boolean,
      default: false,
    },
    disableAddressWhenVillageSelected: {
      type: Boolean,
      default: false,
    },
    locationCardTitle: {
      type: String,
      default: function () {
        return `${this.$t("customers.location")} ${this.$t('customers.types.farmer')}`;
      },
    },
  },
  data() {
    return {
      region: null,
      regionRules: {
        province: "required",
        regency: "required",
        district: "required",
        village: "required",
      },
      farmIdsWithEmptyAddress: this.value
          .filter((farm) => farm.id && !farm.address)
          .map((farm) => farm.id),
    };
  },
  methods: {
    onExistingFarmSelected(farm, value) {
      this.$set(farm, "name", value.name);
      this.$set(farm, "region_id", value.region_id);
      this.$set(farm, "region_full_name", value.region?.full_name || null);
    },
    onFarmRemoved(farm) {
      this.$set(farm, "name", null);
      this.$set(farm, "region_id", null);
      this.$set(farm, "region_full_name", null);
    },
    onUseJalaFarmChanged(farm) {
      this.$set(farm, "name", null);
      this.$set(farm, "total_person", null);
      this.$set(farm, "region_id", null);
      this.$set(farm, "region_full_name", null);
      this.$set(farm, "jala_farm_id", null);
      this.$set(farm, "address", null);
    },
    farmItemKey(farm, key) {
      return farm.id || farm.jala_farm_id || key;
    },
    createFarm() {
      return {
        name: "",
        farmer_name: "",
        address: "",
        code: "",
        total_person: null,
        region_id: null,
        region_full_name: null,
        use_jala_farm: true,
        jala_farm_id: null,
        country_id: "ID",
        currency_id: "IDR",
        timezone: this.$moment().format("Z"),
        latitude: null,
        longitude: null,
        get coordinate() {
          return this.latitude ? `${this.latitude},${this.longitude}` : null;
        },
        set coordinate(value) {
          if (value) {
            const [lat, lng] = (value || "").split(",");
            if (lat != null && Number(lat) && lng != null && Number(lng)) {
              this.latitude = Number(lat);
              this.longitude = Number(lng);
            }
          } else {
            this.latitude = null;
            this.longitude = null;
          }
        },
      };
    },
    addFarm() {
      const farms = [...this.value];
      farms.push(this.createFarm());
      this.$emit("input", farms);
    },
    regionDisables(farm, key) {
      if (this.disableRegionSelectWhenFarmFetched && this.isUntilVillageRegion(this.value[key].region_id)) {
        return ["province", "regency", "district", "village"];
      }
      return [];
    },
    isUntilVillageRegion(regionId) {
      return regionId && regionId.length === 10;
    },
    addressDisabled(farm) {
      if (this.disableAddress) {
        return true;
      }

      if (!farm.id || this.farmIdsWithEmptyAddress.includes(farm.id)) {
        return false;
      }

      return this.disableAddressWhenVillageSelected && this.isUntilVillageRegion(farm.region_id);
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  legend.required-indicator::after {
    content: ' *';
    color: #DC2626;
  }

  .gray-card {
    .card-body {
      background-color: #F9FAFB;
      border-radius: 8px;
    }
  }
}
</style>
